import { c as _c } from "react/compiler-runtime";
import type { Locale } from 'next-intl';
import { LanguagesIcon } from 'lucide-react';
import { useLocale, useTranslations } from 'next-intl';
import { useTransition } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePathname, useRouter } from '@/i18n/navigation';
import { LOCALE_ITEMS } from '@/i18n/routing';
export function LocaleSwitcher() {
  const $ = _c(15);
  const t = useTranslations();
  const locale = useLocale();
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname || $[1] !== router) {
    t0 = function handleLocaleChange(value) {
      if (!value) {
        return;
      }
      startTransition(() => {
        router.replace(pathname, {
          locale: value
        });
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleLocaleChange = t0;
  let t1;
  if ($[3] !== t) {
    t1 = t("layout.change-language");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LanguagesIcon />;
    t3 = <SelectValue />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1) {
    t4 = <SelectTrigger className="w-36" aria-label={t1}>{t2}{t3}</SelectTrigger>;
    $[7] = t1;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SelectContent>{LOCALE_ITEMS.map(_temp)}</SelectContent>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleLocaleChange || $[11] !== isPending || $[12] !== locale || $[13] !== t4) {
    t6 = <Select items={LOCALE_ITEMS} value={locale} onValueChange={handleLocaleChange} disabled={isPending}>{t4}{t5}</Select>;
    $[10] = handleLocaleChange;
    $[11] = isPending;
    $[12] = locale;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(item) {
  return <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>;
}